export default () => ({
  open: false,
  init() {
    this.$watch('open', (value, oldValue) => {
      console.log('watch value:', value, oldValue);
      this.handleDialog(value);
    });

    this.$refs.dialog.addEventListener('close', () => {
      this.$nextTick(() => {
        this.open = false;
        document.querySelector('body').classList.remove('overflow-hidden');
      });
    });
  },
  handleDialog() {
    if (this.open) {
      this.$refs.dialog.showModal();
      document.querySelector('body').classList.add('overflow-hidden');
    } else {
      this.$refs.dialog.close();
    }
  },
});
